import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import axios from "axios";
import route from "../../assets/apiRoutes.json";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
    Editing,
    RequiredRule,

} from "devextreme-react/data-grid";
import { GridLayout } from "../../common/GridLayout";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { Button, SelectBox, TextArea, TextBox } from 'devextreme-react';
import { confirm } from 'devextreme/ui/dialog';
import {FormatPhoneNumber,convertToCustomPhoneFormat} from '../../common/Utils'

let transportCarrier = null;
function MasterDataTab(props) {
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const dataGrid = useRef(null);
    const gridKey = props.gridKey;
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const [allowEdting, setAllowEditing] = useState(false);

    const getDataSource = () => createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${route.ID.GetIDRelationshiplinks}`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${route.ID.InsertIDRelationshiplinks}`,
        loadParams: {
            ROWID: props.RIDMaster,
            IDTYPE: props.IDType,
            IDMEMBERTYPE: props.IDMemeberType,
            NAME: props.TabName
        },
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
            };
        },
    });
    
    const [dataSource] = useState(getDataSource);

    const deleteRecords = useCallback(() => {
        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                if(dataGrid.current){
                  dataGrid.current.instance().beginCustomLoading("Deleting");
                }
                axios.post(
                    `${window._env_.REACT_APP_APIS}/${route.ID.DeleteIDRelationshiplinks}`,
                    selectedItemKeys[0],
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                )
                    .then((res) => {
                        if(dataGrid.current){
                            dataGrid.current.instance().refresh();
                        }
                    }).finally(()=>{
                        if(dataGrid.current){
                            dataGrid.current.instance().endCustomLoading();
                            } 
                    });
            }
        });
    }, [selectedItemKeys]);
    const onEditingStart = (e) => {
        if (e.data.rowid) {
            e.cancel = true;
        }

    };
    const handleCellValueChanged = (data) => {
        if(data.selectedRowsData.length>0)
         setSelectedItemKeys(data.selectedRowsData);
    }

    const onInitNewRow = (e) => {
        //if (!e.data) {
        setAllowEditing(true);
        e.data.RIDMASTER = props.RIDMaster;
        e.data.IDMASTERTYPE = props.IDType;
        e.data.IDMEMBERTPE = props.IDMemeberType;
        //}
    };
    const onRowInserting = (e) => {
        e.data.telephonE1 = convertToCustomPhoneFormat(e.data.telephonE1);
        e.data.telephonE2 = convertToCustomPhoneFormat(e.data.telephonE2);
        e.data.cellphonE1 = convertToCustomPhoneFormat(e.data.cellphonE1);
        e.data.cellphonE2 = convertToCustomPhoneFormat(e.data.cellphonE2);
        e.data.pageR1 = convertToCustomPhoneFormat(e.data.pageR1);
        e.data.pageR2 = convertToCustomPhoneFormat(e.data.pageR2);
    };
    const onRowInserted = (e) => {
        setAllowEditing(false);
    };


    return (
        <div className="FormMt">
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                dataSource={dataSource}
                ref={dataGrid}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={handleCellValueChanged}
                onInitNewRow={onInitNewRow}
                onRowInserting={onRowInserting}
                onRowInserted={onRowInserted}
                onRowUpdating={(e) => {
                    // Block updating existing rows
                    if (!e.oldData.__isNew) {
                      e.cancel = true;
                    }
                  }}
                onEditCanceled={()=>setAllowEditing(false)}
                height="100%"
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling mode="standard" />
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />
                <Editing
                    mode="cell"
                    refreshMode="repaint"
                    allowUpdating={true}
                    allowAdding={true}
                />

                <FilterRow visible={true} />
                <Column dataField="keysequence" caption='Key Sequence' visible={false} allowSorting={false} showInColumnChooser={false} />
                <Column dataField="rowid" caption='rowid' visible={false} allowSorting={false} showInColumnChooser={false} />
                <Column dataField="identityid" caption="Identity ID" dataType="string" allowEditing={allowEdting}>
                    <RequiredRule message={" Identity ID is required."}></RequiredRule>
                </Column>
                <Column dataField="name" caption="Name" dataType="string" allowEditing={allowEdting}/>
                <Column dataField="telephonE1" caption="Telephone" dataType="string" allowEditing={allowEdting} editorOptions={{ mask: '0000(000000)0000000000,0000000'}} 
                cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
                <Column dataField="telephonE2" caption="Telephone 2" dataType="string"  allowEditing={allowEdting}   editorOptions={{mask: '0000(000000)0000000000,0000000'}}
                cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}
                />
                {
                    props.TabName === "AllContacts" ? (
                        <Column dataField="description" caption="Description" dataType="string" allowEditing={false}/>

                    ) :
                        (
                            <Column dataField="webUserName" caption="Web User Name" dataType="string" allowEditing={false}/>
                        )
                }

                <Column allowEditing={allowEdting} visible={false} dataField="addressname" caption="Address Name" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="addresS1" caption="Address" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="addresS2" caption="Address 2" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="city" caption="City" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="state" caption="State" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="zip" caption="ZIP" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="country" caption="Country" dataType="string" />
                <Column visible={false} dataField="creationuserid" caption="Created By" dataType="string" allowEditing={false} />
                <Column visible={false} dataField="creationdatetime" caption="Creation Date" dataType="date" allowEditing={false} />
                <Column visible={false} dataField="lastupdatedatetime" caption="Last Updated" dataType="string" allowEditing={false} />
                <Column visible={false} dataField="lastupdateuserid" caption="Last Updated By" dataType="date" allowEditing={false} />
                <Column allowEditing={allowEdting} visible={false} dataField="faX1" caption="Fax" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="faX2" caption="Fax 2" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="modeM1" caption="Modem" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="modeM2" caption="Modem 2" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="cellphonE1" caption="Cell Phone" dataType="string"  editorOptions={{ mask: '0000(000000)0000000000,0000000'}}  cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
                <Column allowEditing={allowEdting} visible={false} dataField="cellphonE2" caption="Cell Phone 2" dataType="string"  editorOptions={{ mask: '0000(000000)0000000000,0000000'}}  cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
                <Column allowEditing={allowEdting} visible={false} dataField="pageR1" caption="Pager 1" dataType="string"  editorOptions={{ mask: '0000(000000)0000000000,0000000'}}   cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
                <Column allowEditing={allowEdting} visible={false} dataField="pageR2" caption="Pager 2" dataType="string"  editorOptions={{ mask: '0000(000000)0000000000,0000000'}}   cellRender={cellData  => <div>{FormatPhoneNumber(cellData.value)}</div>}/>
                <Column allowEditing={allowEdting} visible={false} dataField="emailaddresS1" caption="Email Address" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="emailaddresS2" caption="Email Address 2" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="websiteaddresS1" caption="Web 1" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="websiteaddresS2" caption="Web 2" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="contactid" caption="Contact ID" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="contactname" caption="Contact Name" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="idgroup" caption="ID Group" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="idsubgroup" caption="ID Subgroup" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="referencE1" caption="Reference 1" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="referencE2" caption="Reference 2" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="userdefinedcodE1" caption="Contacts UDC_1" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="userdefinedcodE2" caption="Contacts UDC_2" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="userdefinedcodE3" caption="Contacts UDC_3" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="userdefinedcodE4" caption="Contacts UDC_4" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="userdefinedcodE5" caption="Contacts UDC_5" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="userdefinedcodE6" caption="Contacts UDC_6" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="userdefinedcodE7" caption="Contacts UDC_7" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="userdefinedcodE8" caption="Contacts UDC_8" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="userdefinedcodE9" caption="Contacts UDC_9" dataType="string" />
                <Column allowEditing={allowEdting} visible={false} dataField="userdefinedcodE10" caption="Contacts UDC_10" dataType="string" />
                <Column  visible={false} dataField="module" caption="Module" dataType="string" allowEditing={false} />
                <Column  visible={false} dataField="companyid" caption="Company ID" dataType="string" allowEditing={false} />
                <Toolbar>
                    <Item
                        name="addRowButton"
                        disabled={props.TabName === "AllContacts"}
                    />
                    <Item location="after">
                        <Button
                            onClick={deleteRecords}
                            icon="trash"
                            disabled={!selectedItemKeys[0]}
                        />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(MasterDataTab);